import {IngestionMessage} from "../asset-service-api";
import {useProjects} from "../Behaviors/projects";
import { useStore } from "../State/zustandStore";

export const useHdValidator = (projId?: string | undefined) => {
    const workspaceState = useStore().projects;
    const projectId = workspaceState.selectedProjectId ?? projId;
    const {project, getMappedResources, getMappedTrack} = useProjects(projectId!);
    const mappedResource = getMappedResources(project);
    const isProductHd = () => {
        const releaseInfo = project?.releaseInfo;

        switch (releaseInfo?.configuration) {
        case "eAlbum Audio + Booklet HD":
        case "eAlbum Audio HD":
        case "eAudio Stem Bundle HD":
        case "eFixedPlaylist Audio HD":
        case "eSingle Audio/Multi Track + Booklet HD":
        case "eSingle Audio/Multi Track HD":
        case "eSingle Audio/Single Track + Booklet HD":
        case "eSingle Audio/Single Track HD":
        case "eAlbum Audio (Sollos) HD":
        case "eSingle Audio/Single Track (Sollos) HD":
        case "eSingle Audio/Multi Track (Sollos) HD":
        case "eMix Bundle Album HD":
        case "eMix Bundle Album + Booklet HD":
        case "eMix Bundle Album + LP HD":
        case "eMix Bundle Single HD":
        case "eMix Bundle Single + Booklet HD":
            return true;
        default:
            return false;
        }
    };

    const isExplicit = () => {
        const releaseInfo = project?.releaseInfo;

        switch (releaseInfo?.parentalAdvisory) {
        case "Non-Applicable":
            return false;
        default:
            return true;
        }
    };
    const getHDValidationErrors = (): IngestionMessage[] => {
        const releaseInfo = project?.releaseInfo;
        const allowedChannels = 2;

        if (isProductHd()) {
            const errorMessages = mappedResource.filter(x => x.filename?.toLowerCase().endsWith(".wav") && (x.audioInfo?.bit_depth ?? 0) < 24).map(x => {
                return {
                    details: `Asset ${ x.filename }, assigned to Track ${ getMappedTrack(project!, x)?.number }, Bit Depth (${ x.audioInfo?.bit_depth }) is less than the allowed minimum (24) for configuration ${ releaseInfo!.configuration }.`,
                    message: "WAV assets on HD products must have minimum Bit Depth 24.",
                    messageType: "Error",
                    source: {
                        scope: "Track",
                        stage: "local",
                        target: getMappedTrack(project!, x)?.number.toString(),
                        id: "7e7f7c03-5c8b-46bb-b62f-6b237a9d0f25",
                    },
                } as IngestionMessage;
            });

            errorMessages.push(...mappedResource.filter(x => x.filename?.toLowerCase().endsWith(".dsf") && (x.audioInfo?.sample_rate ?? 0) < 2822400).map(x => {
                return {
                    details: `Asset ${ x.filename }, assigned to Track ${ getMappedTrack(project!, x)?.number }, Bit Depth (${ x.audioInfo?.sample_rate }) is less than the allowed minimum (2822400) for configuration ${ releaseInfo!.configuration }.`,
                    message: "DSF assets on HD products must have minimum Sample Rate 2822400.",
                    messageType: "Error",
                    source: {
                        scope: "Track",
                        stage: "local",
                        target: getMappedTrack(project!, x)?.number.toString(),
                        id: "d27e37af-5bce-440b-8ccb-794f47919f6b",
                    },
                } as IngestionMessage;
            }));

            errorMessages.push(...mappedResource.filter(x => (x.audioInfo?.channels ?? 0) !== allowedChannels).map(x => {
                return {
                    message: `File has ${x.audioInfo?.channels ?? 0} audio channels. This product configuration requires ${allowedChannels} channels.`,
                    messageType: "Error",
                    source: {
                        scope: "Track",
                        stage: "local",
                        target: getMappedTrack(project!, x)?.number.toString(),
                        id: "05377e7b-8936-4112-b45d-e362c46d2ff2",
                    },
                } as IngestionMessage;
            }));
            return errorMessages;
        } else return [];
    };
    return { getHDValidationErrors, isExplicit, isProductHd};

};
